import React from "react";

import { BlockRegister } from "../components/BlockRegister";

const Register = () => {
  return (
    <BlockRegister />
  );
};

export default Register;